import * as i0 from '@angular/core';
import { forwardRef, EventEmitter, Component, ViewChild, ContentChildren, Input, Output, NgModule } from '@angular/core';
import * as i3 from '@angular/forms';
import { NG_VALUE_ACCESSOR, FormsModule } from '@angular/forms';
import { fromEvent } from 'rxjs';
import * as i1 from '@appkit4/angular-api';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i4 from 'ng-click-outside2';
import { NgClickOutsideDirective } from 'ng-click-outside2';
import { DropdownListItemModule } from '@appkit4/angular-components/dropdown-list-item';

const SEARCH_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => SearchComponent),
    multi: true,
};
class SearchComponent {
    constructor(render, element, cd, localizationConfig) {
        this.render = render;
        this.element = element;
        this.cd = cd;
        this.localizationConfig = localizationConfig;
        this.tabindex = 0;
        this.role = "search";
        this.searchType = "primary";
        this.autocomplete = "off";
        this.filtered = false;
        this.list = [];
        this.isRecentSearch = false;
        this.customKeydown = false;
        this.onSearch = new EventEmitter();
        this.onFocus = new EventEmitter();
        this.onBlur = new EventEmitter();
        this.onClear = new EventEmitter();
        this.onKeydown = new EventEmitter();
        this.onSaveLocalHistory = new EventEmitter();
        this.onClose = new EventEmitter();
        this.value = "";
        this.onModelChange = () => { };
        this.onModelTouched = () => { };
        this.activeSearch = false;
        this.fileldActiveDelete = false;
        this.showList = false;
        this.showBlankPage = false;
        this.tempList = [];
        this.isFocusDelIcon = false;
        this.searchHistoryList = [];
        this.showHistoryMsg = false;
        this.optionName = 'label';
        this.optionValue = "value";
        this.allowDataLoad = true;
        this.originalData = [];
        this.onInputChange = (event) => {
            let inputV = this.inputViewChild.nativeElement.value.trim();
            this.onModelChange(inputV);
            if (inputV.length > 0) {
                switch (this.searchType) {
                    case 'primary':
                        this.showPressIcon = true;
                        break;
                    case 'secondary': {
                        this.showDeleteIcon = true;
                        this.fileldActiveDelete = true;
                        this.value = this.inputViewChild.nativeElement.value.trim();
                        if (this.filtered) {
                            let result = this.filterOption(inputV, this.originalData);
                            this.showList = true;
                            this.blankPage(result);
                            if (this.isRecentSearch) {
                                this.showHistoryMsg = false;
                            }
                            this.removeFocusKeyboard(result);
                            this.allowDataLoad = false;
                            this.onSearch.emit({
                                originEvent: event,
                                queryStr: inputV,
                                result: result
                            });
                        }
                        else {
                            this.allowDataLoad = false;
                            this.onSearch.emit({
                                originEvent: event,
                                queryStr: inputV
                            });
                        }
                        break;
                    }
                }
            }
            else {
                this.activeSearch = false;
                switch (this.searchType) {
                    case 'primary':
                        this.showPressIcon = false;
                        break;
                    case 'secondary':
                        this.showDeleteIcon = true;
                        this.fileldActiveDelete = false;
                        if (this.filtered) {
                            this.showBlankPage = true;
                            if (this.isRecentSearch) {
                                this.showHistoryMsg = false;
                            }
                            this.showList = true;
                        }
                        break;
                }
                this.allowDataLoad = false;
                this.onSearch.emit({
                    originEvent: event,
                    queryStr: inputV,
                });
                if (this.originalData[0]?.type) {
                    for (let g = 0; g < this.originalData.length; g++) {
                        let content = this.originalData[g].items;
                        for (let j = 0; j < content.length; j++) {
                            content[j].checked = false;
                        }
                    }
                }
                else {
                    for (let dl of this.originalData) {
                        dl.checked = false;
                    }
                }
            }
        };
        this.OnInputFocus = (event) => {
            event.preventDefault();
            event.stopPropagation();
            this.render.addClass(this.element.nativeElement.querySelector('.ap-search-input'), 'focus');
            this.value = this.inputViewChild.nativeElement.value.trim();
            let type = this.searchType;
            switch (type) {
                case "primary":
                    if (this.value.length > 0) {
                        this.showPressIcon = true;
                    }
                    break;
                case "secondary":
                    this.showDeleteIcon = true;
                    if (this.value.length > 0) {
                        this.fileldActiveDelete = true;
                        if (this.filtered) {
                            let result = this.filterOption(this.value, this.originalData);
                            this.showList = true;
                            this.allowDataLoad = false;
                            this.onSearch.emit({
                                originEvent: event,
                                queryStr: this.value,
                                result: result
                            });
                            this.removeFocusKeyboard(result);
                            this.blankPage(result);
                            if (this.isRecentSearch) {
                                // this.itemActiveDelete = false;
                                this.showHistoryMsg = false;
                            }
                        }
                    }
                    else {
                        this.fileldActiveDelete = false;
                    }
                    break;
            }
            this.onModelChange(this.value);
            this.allowDataLoad = false;
            this.onFocus.emit({
                originEvent: event,
                queryStr: this.value,
            });
        };
        this.getNextFocusableElement = (findElement, element) => {
            const controls = `button:not([tabindex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden]),
    [href][clientHeight][clientWidth]:not([tabindex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden]),
    input:not([tabindex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden]),
    select:not([tabindex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden]),
    textarea:not([tabindex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden]),
    [tabIndex]:not([tabIndex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden]),
    [contenteditable]:not([tabIndex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden])`;
            let focusable = findElement?.querySelectorAll(controls); //(containerRef.current! as HTMLElement)?
            const index = Array.prototype.indexOf.call(Array.from(focusable), element);
            return Array.from(focusable)[index + 1];
        };
        this.getLastFocusableElement = (findElement, element) => {
            const controls = `button:not([tabindex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden]),
    [href][clientHeight][clientWidth]:not([tabindex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden]),
    input:not([tabindex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden]),
    select:not([tabindex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden]),
    textarea:not([tabindex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden]),
    [tabIndex]:not([tabIndex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden]),
    [contenteditable]:not([tabIndex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden])`;
            let focusable = findElement?.querySelectorAll(controls); //(containerRef.current! as HTMLElement)?
            const index = Array.prototype.indexOf.call(Array.from(focusable), element);
            return Array.from(focusable)[index - 1];
        };
        this.blankPage = (result) => {
            this.showBlankPage = !(result && result.length > 0);
        };
        this.filterOption = (searchValue, options) => {
            const queryStr = searchValue.toUpperCase().trim();
            const queryResult = [];
            if (queryStr.length > 0) {
                if (options[0]?.type) {
                    options.forEach(item => {
                        const groupList = [];
                        if (item.label.toUpperCase().includes(queryStr)) {
                            queryResult.push(item);
                        }
                        else {
                            for (let index in item.items) {
                                if (item.items[index].label.toUpperCase().includes(queryStr)) {
                                    groupList.push(item.items[index]);
                                }
                            }
                            if (groupList.length > 0) {
                                queryResult.push({ type: item.type, label: item.label, items: groupList });
                            }
                        }
                    });
                }
                else {
                    for (let index in options) {
                        if (options[index].label.toUpperCase().includes(queryStr)) {
                            queryResult.push(options[index]);
                        }
                    }
                }
                return queryResult;
            }
            else {
                // return options;
            }
        };
        this.onClickOutside = () => {
            this.showList = false;
        };
    }
    ngOnInit() {
        if (this.disabled) {
            this.tabindex = -1;
        }
        if (!this.inputId) {
            this.inputId = 'searchInput' + String.fromCharCode(65 + Math.floor(Math.random() * 26)) + Date.now();
        }
        this.showPressIcon = false;
        this.showDeleteIcon = false;
        this.element.nativeElement.children[0].style.cssText = this.style;
        this.keydownObservable$ = fromEvent(window, 'keydown');
        this.keydownSubscription$ = this.keydownObservable$.subscribe((event) => {
            const keycode = window.event ? event.keyCode : event.which;
            if (keycode === 9) {
                this.render.addClass(this.element.nativeElement.querySelector('.ap-search-input'), 'keyboard-focus');
            }
        });
        this.clickObservable$ = fromEvent(window, 'click');
        this.clickSubscription$ = this.clickObservable$.subscribe((event) => {
            this.render.removeClass(this.element.nativeElement.querySelector('.ap-search-input'), 'keyboard-focus');
        });
    }
    ngOnChanges(changes) {
        for (let propName in changes) {
            let change = changes[propName];
            if (propName === 'list' && change.currentValue) {
                this.list = [...change.currentValue];
                if (this.allowDataLoad) {
                    this.originalData = [...change.currentValue];
                }
                else {
                    this.allowDataLoad = false;
                }
                setTimeout(() => {
                    this.dropdownListItem.toArray().forEach((o) => {
                        // o.enableEmitItem = true;
                        o.onSelectItem.subscribe((event) => {
                            this.onItemSelected(event);
                        });
                    });
                }, 0);
            }
            if (propName === 'ariaLabel' && change.currentValue) {
                this.ariaLabel = change.currentValue;
            }
            if (propName === 'style' && change.currentValue) {
                this.style = change.currentValue;
                this.element.nativeElement.children[0].style.cssText = this.style;
            }
            if (propName === 'noHistoryMsg' && change.currentValue) {
                this.noHistoryMsg = change.currentValue;
            }
            if (propName === 'disabled' && change.currentValue) {
                this.disabled = change.currentValue;
                if (this.disabled)
                    this.showList = false;
            }
        }
    }
    // setValid(): ValidationErrors { return null };
    // onValidationChange = () => { };
    // validate(control: AbstractControl): ValidationErrors {
    //   return this.setValid();
    // }
    // registerOnValidatorChange?(fn: () => void): void {
    //   this.onValidationChange = fn;
    // }
    onItemSelected(event) {
        event.originEvent?.preventDefault();
        this.inputViewChild.nativeElement.value = event.selected.label;
        this.value = event.selected.label;
        if (this.searchType === 'secondary' && this.value.length > 0) {
            this.fileldActiveDelete = true;
        }
        this.onModelChange(this.value);
        this.showList = false;
        if (this.originalData[0]?.type) {
            for (let g = 0; g < this.originalData.length; g++) {
                let content = this.originalData[g].items;
                for (let j = 0; j < content.length; j++) {
                    content[j].checked =
                        content[j][this.optionValue] ===
                            event.selected[this.optionValue];
                }
            }
        }
        else {
            for (let dl of this.originalData) {
                dl.checked =
                    event.selected[this.optionValue] === dl[this.optionValue];
            }
        }
    }
    ;
    onStartSearch(event) {
        this.showPressIcon = false;
        this.value = this.inputViewChild.nativeElement.value;
        if (this.value.length > 0) {
            this.activeSearch = true;
        }
        this.allowDataLoad = false;
        this.onSearch.emit({
            originEvent: event,
            queryStr: this.value,
        });
        this.onModelChange(this.value);
        this.inputViewChild.nativeElement.blur();
        this.priamryIcon.nativeElement.blur();
    }
    removeFocusKeyboard(list) {
        for (let index of Object.keys(list)) {
            if (list[index].focused) {
                list[index].focused = false;
            }
        }
    }
    OnInputBlur(event) {
        this.render.removeClass(this.element.nativeElement.querySelector('.ap-search-input'), 'focus');
        this.value = this.inputViewChild.nativeElement.value.trim();
        let type = this.searchType;
        switch (type) {
            case "primary":
                if (this.value.length > 0) {
                    this.activeSearch = true;
                }
                else {
                    this.activeSearch = false;
                }
                break;
            case "secondary":
                if (this.value.length > 0) {
                    this.showDeleteIcon = true;
                    this.fileldActiveDelete = true;
                    this.activeSearch = true;
                }
                else {
                    this.showDeleteIcon = false;
                    this.fileldActiveDelete = false;
                    this.activeSearch = false;
                }
                // if(this.showList) {
                //   this.showList = false;
                // }
                break;
        }
        this.onModelChange(this.value);
        this.allowDataLoad = false;
        this.onBlur.emit({
            originEvent: event,
            queryStr: this.value,
        });
    }
    onDeleteInput(event) {
        let value = "";
        this.inputViewChild.nativeElement.value = "";
        this.inputViewChild.nativeElement.focus();
        this.fileldActiveDelete = false;
        // this.list = [];
        if (this.filtered) {
            this.showBlankPage = true;
            this.showList = true;
        }
        this.onModelChange(value);
        this.allowDataLoad = false;
        this.onClear.emit({
            originEvent: event,
            queryStr: value,
        });
        if (this.originalData[0]?.type) {
            for (let g = 0; g < this.originalData.length; g++) {
                let content = this.originalData[g].items;
                for (let j = 0; j < content.length; j++) {
                    content[j].checked = false;
                }
            }
        }
        else {
            for (let dl of this.originalData) {
                dl.checked = false;
            }
        }
    }
    writeValue(val) {
        setTimeout(() => {
            if (this.inputViewChild && this.inputViewChild.nativeElement) {
                this.inputViewChild.nativeElement.value = val;
                if (!val) {
                    this.showDeleteIcon = false;
                    this.activeSearch = false;
                }
                if (this.filtered && this.list) {
                    let length = this.list.length - 1;
                    this.tempItem = this.list[length];
                }
            }
            this.cd.markForCheck();
        }, 0);
    }
    registerOnChange(fn) {
        this.onModelChange = fn;
    }
    registerOnTouched(fn) {
        this.onModelTouched = fn;
    }
    // setDisabledState?(val: boolean): void {
    //   // this.disabled = val;
    //   this.cd.markForCheck();
    // }
    onInputKeydown(event) {
        this.onKeydown.emit(event);
    }
    onSearchContainerKeyUp(event) {
        let eventCode = event.keyCode;
        let searchEle = this.searchContainer.nativeElement;
        let activeEle = document.activeElement;
        let iscontain = searchEle.contains(activeEle);
        this.nextFocusEle = this.getNextFocusableElement(searchEle, activeEle);
        this.preFocusEle = this.getLastFocusableElement(searchEle, activeEle);
        if (eventCode === 9 && !iscontain && this.showList) {
            this.showList = false;
        }
    }
    onSearchContainerKeyDown(event) {
        if (event.keyCode === 9 && !event.shiftKey) {
            if (this.nextFocusEle === undefined && this.showList) {
                this.showList = false;
            }
        }
        else if (event.keyCode === 9 && event.shiftKey) {
            if (this.preFocusEle === undefined && this.showList) {
                this.showList = false;
            }
        }
    }
    onSearchKeydown(event) {
        if (!this.customKeydown) {
            let keyCode = event.keyCode;
            switch (keyCode) {
                case 27: //esc
                    if (this.filtered) {
                        if (this.showList) {
                            this.showList = false;
                            this.onClose.emit(event);
                        }
                        if (!this.showList) {
                            let value = "";
                            this.inputViewChild.nativeElement.value = "";
                            this.inputViewChild.nativeElement.focus();
                            this.fileldActiveDelete = false;
                        }
                    }
                    event.preventDefault();
                    break;
                case 40: //down
                    if (this.isFocusDelIcon) {
                        this.isFocusDelIcon = false;
                        this.secondaryDelIcon.nativeElement.blur();
                        this.inputViewChild.nativeElement.focus();
                    }
                    if (this.filtered) {
                        if (event.altKey) {
                            this.showList = true;
                            this.setNextMoved();
                        }
                        else {
                            this.findDownNext(this.tempItem);
                        }
                    }
                    event.stopPropagation();
                    event.preventDefault();
                    break;
                case 38: //up
                    if (this.isFocusDelIcon) {
                        this.isFocusDelIcon = false;
                        this.secondaryDelIcon.nativeElement.blur();
                        this.inputViewChild.nativeElement.focus();
                    }
                    if (this.filtered) {
                        this.findeUpNext(this.tempItem);
                    }
                    event.stopPropagation();
                    event.preventDefault();
                    break;
                case 13: //enter   
                    if (this.searchType === 'primary') {
                        this.onStartSearch(event);
                    }
                    else if (this.searchType === 'secondary') {
                        let eleClassName = event.target.className;
                        if (eleClassName.indexOf('delete-icon') > -1) {
                            this.onDeleteInput(event);
                            return;
                        }
                        if (this.filtered) {
                            if (!this.showList) {
                                let sv = this.inputViewChild.nativeElement.value.trim();
                                if (sv.length > 0) {
                                    this.OnInputFocus(event);
                                }
                            }
                            else {
                                this.showList = false;
                            }
                            let selectTemp = this.dropdownListItem.toArray().find((o) => o.item.focused === true);
                            if (selectTemp) {
                                selectTemp.onSelectItem.next({ originEvent: event, selected: this.tempItem, eventType: 'keydown' });
                            }
                        }
                    }
                    event.preventDefault();
                    break;
                // case 32: //space
                //   if (this.searchType === 'primary') {
                //     this.onStartSearch(event);
                //   } else if (this.searchType === 'secondary') {
                //     let eleClassName = event.target.className;
                //     if (eleClassName.indexOf('delete-icon') > -1) {
                //       this.onDeleteInput(event);
                //       return;
                //     }
                //     if (this.filtered) {
                //       if (!this.showList) {
                //         let sv = this.inputViewChild.nativeElement.value.trim();
                //         if (sv.length > 0) {
                //           this.OnInputFocus(event);
                //         }
                //       } else {
                //         this.showList = false;
                //       }
                //       let selectTemp = this.dropdownListItem.toArray().find((o: any) => o.item.focused === true);
                //       if(selectTemp) {
                //           selectTemp.onSelectItem.next({ originEvent: event, selected: this.tempItem, eventType: 'keydown' });
                //       }
                //     }
                //   }
                //   break;
                case 9: //tab
                    if (this.showList) {
                        this.showList = true;
                        if (this.nextFocusEle === undefined && this.showList) {
                            this.showList = false;
                        }
                    }
                    break;
            }
        }
    }
    onFocusDelIcon() {
        this.isFocusDelIcon = true;
    }
    onBlurDelIcon() {
        this.isFocusDelIcon = false;
    }
    onClickOut(event) {
        // ccheck if click on current element
        if (event.target.shadowRoot) {
            // check before go through path element to reduce time
            if (!this.showList) {
                return;
            }
            const path = event.composedPath();
            let self = false;
            for (let i = 0; i < 5; i++) {
                if (path[i] && path[i].id && path[i].id.indexOf(this.inputId) !== -1) {
                    self = true;
                    break;
                }
            }
            if (self) {
                return;
            }
        }
        this.onClickOutside();
    }
    findOptionIndex(val, opts) {
        let index = -1;
        if (opts && val !== null && val !== undefined) {
            for (let i = 0; i < opts.length; i++) {
                if (opts[i].label === val.label) {
                    index = i;
                    break;
                }
            }
        }
        return index;
    }
    findDownNext(nextItem) {
        if (!this.showBlankPage) {
            this.tempItem = nextItem;
            let selectedItemIndex = this.findOptionIndex(this.tempItem, this.list);
            if (selectedItemIndex !== -1) {
                let nextItemIndex = selectedItemIndex + 1;
                if (nextItemIndex < this.list.length) {
                    this.tempItem = this.list[nextItemIndex];
                }
                else {
                    this.tempItem = this.list[0];
                }
            }
            else {
                this.tempItem = this.list[0];
            }
            if (this.tempItem.disabled) {
                this.findDownNext(this.tempItem);
            }
            else {
                this.setNextMoved();
            }
        }
    }
    findeUpNext(nextItem) {
        if (!this.showBlankPage) {
            this.tempItem = nextItem;
            let selectedItemIndex = this.findOptionIndex(this.tempItem, this.list);
            if (selectedItemIndex !== -1) {
                let preItemIndex = selectedItemIndex - 1;
                if (preItemIndex >= 0) {
                    this.tempItem = this.list[preItemIndex];
                }
                else {
                    let length = this.list.length - 1;
                    this.tempItem = this.list[length];
                }
            }
            else {
                let length = this.list.length - 1;
                this.tempItem = this.list[length];
            }
            if (this.tempItem.disabled) {
                this.findeUpNext(this.tempItem);
            }
            else {
                this.setNextMoved();
            }
        }
    }
    setNextMoved() {
        for (let index of Object.keys(this.list)) {
            let item = this.list[index];
            if (item.label === this.tempItem.label) {
                this.list[index].focused = true;
            }
            else {
                this.list[index].focused = false;
            }
        }
        this.getActiveItemId();
    }
    getActiveItemId() {
        setTimeout(() => {
            this.itemNodeList = this.element.nativeElement.querySelectorAll('.ap-option-item');
            let currentEle = this.element.nativeElement.querySelector('.ap-option-item.moved');
            this.itemNodeList.forEach(item => {
                if (item === currentEle) {
                    this.activeId = item.id;
                }
            });
        });
    }
    ngOnDestroy() {
        this.keydownSubscription$?.unsubscribe();
        this.clickSubscription$?.unsubscribe();
    }
    getLabel(labelKey) {
        return this.localizationConfig.translation ? this.localizationConfig.translation[labelKey] : null;
    }
    get _noResultMessage() {
        return this.noResultMsg || this.noResultMsg === ""
            ? this.noResultMsg
            : this.localizationConfig.translation ? this.localizationConfig.translation['noResultMessage'] : null;
    }
    get _noHistoryMessage() {
        return this.noHistoryMsg || this.noHistoryMsg === ""
            ? this.noHistoryMsg
            : this.localizationConfig.translation ? this.localizationConfig.translation['noHistoryMessage'] : null;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: SearchComponent, deps: [{ token: i0.Renderer2 }, { token: i0.ElementRef }, { token: i0.ChangeDetectorRef }, { token: i1.LocalizationConfig }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.11", type: SearchComponent, selector: "ap-search", inputs: { disabled: "disabled", tabindex: "tabindex", ariaLabel: "ariaLabel", autoFocus: "autoFocus", role: "role", error: "error", readonly: "readonly", placeholder: "placeholder", inputId: "inputId", searchType: "searchType", autocomplete: "autocomplete", filtered: "filtered", list: "list", styleClass: "styleClass", style: "style", addDropdown: "addDropdown", showPressIcon: "showPressIcon", showDeleteIcon: "showDeleteIcon", noResultMsg: "noResultMsg", noHistoryMsg: "noHistoryMsg", isRecentSearch: "isRecentSearch", customKeydown: "customKeydown", searchStatus: "searchStatus", optionName: "optionName", optionValue: "optionValue" }, outputs: { onSearch: "onSearch", onFocus: "onFocus", onBlur: "onBlur", onClear: "onClear", onKeydown: "onKeydown", onSaveLocalHistory: "onSaveLocalHistory", onClose: "onClose" }, providers: [SEARCH_VALUE_ACCESSOR], queries: [{ propertyName: "dropdownListItem", predicate: ["dropdownListItem"] }], viewQueries: [{ propertyName: "inputViewChild", first: true, predicate: ["searchInput"], descendants: true }, { propertyName: "priamryIcon", first: true, predicate: ["primaryIcon"], descendants: true }, { propertyName: "secondaryDelIcon", first: true, predicate: ["secondaryDelIcon"], descendants: true }, { propertyName: "searchContainer", first: true, predicate: ["searchContainer"], descendants: true }], exportAs: ["apSearch"], usesOnChanges: true, ngImport: i0, template: "<form\n  #searchContainer\n  class=\"ap-search-container {{ styleClass }}\"\n  [class.show]=\"showList\"\n  (keyup)=\"onSearchContainerKeyUp($event)\"\n  (keydown)=\"onSearchContainerKeyDown($event)\"\n  (clickOutside)=\"onClickOut($event)\">\n  <div class=\"search-result\"  aria-live=\"assertive\" aria-atomic= \"true\">{{ searchStatus }}</div>\n  <div\n    class=\"ap-search-input\"\n    [class.disabled]=\"disabled\"\n    (keydown)=\"onSearchKeydown($event)\">\n    <input\n      type=\"text\"\n      #searchInput\n      [attr.role]=\"role\"\n      class=\"ap-field-input\"  \n      [attr.autocomplete]=\"autocomplete\"\n      [attr.aria-disabled]=\"disabled\"\n      [attr.aria-label]=\"ariaLabel\"\n      [attr.id]=\"inputId\"\n      [tabindex]=\"tabindex\"\n      [attr.aria-activedescendant]=\"activeId ? activeId : null \"\n      [attr.autofocus]=\"autoFocus\"\n      [class.disabled]=\"disabled\"\n      [class.error]=\"error\"\n      [class.readonly]=\"readonly\"\n      [placeholder]=\"placeholder\"\n      [disabled]=\"disabled\"\n      (input)=\"onInputChange($event)\"\n      (focus)=\"OnInputFocus($event)\"\n      (blur)=\"OnInputBlur($event)\"\n      (keydown)=\"onInputKeydown($event)\"\n      />\n    <span\n      class=\"Appkit4-icon icon-search-outline\"\n      [class.activeSearch]=\"activeSearch\"\n      [attr.aria-hidden]=\"true\"></span>\n\n    <span\n      *ngIf=\"searchType === 'primary'\"\n      role=\"button\"\n      #primaryIcon\n      [attr.tabindex]=\"tabindex || (!showPressIcon ? -1 : 0)\"\n      [attr.aria-label]=\"getLabel('search')\"\n      [attr.aria-disabled]=\"!showPressIcon\"\n      [attr.aria-hidden]=\"!showPressIcon\"\n      [tabindex]=\"disabled ? -1 : 0\"\n      [class.showPressIcon]=\"showPressIcon\"\n      [class.disabled]=\"disabled\"\n      class=\"ap-search-after-icon enter-icon\"\n      (click)=\"onStartSearch($event)\">\n      <span [attr.aria-hidden]=\"true\" class=\"Appkit4-icon icon-return-outline\"></span>\n    </span>\n\n    <span\n      #secondaryDelIcon\n      *ngIf=\"searchType !== 'primary'\"\n      role=\"button\"\n      type=\"button\"\n      [class.showDeleteIcon]=\"showDeleteIcon\"\n      [class.active]=\"fileldActiveDelete\"\n      [class.disabled]=\"disabled\"\n      class=\"ap-search-after-icon delete-icon\"\n      [attr.aria-label]=\"getLabel('clear')\"\n      [attr.aria-disabled]=\"!fileldActiveDelete\"\n      [attr.tabindex]=\"tabindex || (!fileldActiveDelete ? -1 : 0)\"\n      (focus)=\"onFocusDelIcon()\"\n      (blur)=\"onBlurDelIcon()\"\n      (click)=\"fileldActiveDelete && onDeleteInput($event)\">\n      <span class=\"Appkit4-icon icon-circle-delete-outline\"></span>\n    </span>\n  </div>\n  <ng-container>\n    <div class=\"ap-search-list\" *ngIf=\"showList\" [attr.role]=\"'listbox'\" [attr.aria-label]=\"'Option List'\">\n      <ng-content></ng-content>\n      <ng-container *ngIf=\"showBlankPage\">\n        <ng-container *ngIf=\"!isRecentSearch\">\n          <div class=\"ap-option-item noResult\" role=\"option\"> \n            <span class=\"ap-option-label\">{{ _noResultMessage }}</span>\n          </div>\n        </ng-container>\n        <ng-container *ngIf=\"isRecentSearch\">\n          <div class=\"ap-option-item noResult\" role=\"option\">\n            <span *ngIf=\"!showHistoryMsg\" class=\"ap-option-label\">{{\n              _noResultMessage\n              }}</span>\n            <span *ngIf=\"showHistoryMsg\" class=\"ap-option-label\">{{\n              _noHistoryMessage\n              }}</span>\n          </div>\n        </ng-container>\n      </ng-container>\n    </div>\n  </ng-container>\n</form>\n", styles: [":host ::ng-deep .ap-search-input{position:relative;display:flex;align-items:center;flex-wrap:wrap;margin-bottom:0;box-shadow:inset 0 0 0 .0625rem var(--color-background-border);background-color:var(--color-background-container);border-radius:var(--border-radius-2);overflow:hidden;transition:color .3s,background-color .3s,box-shadow .3s}:host ::ng-deep .ap-search-input:hover:not(.disabled){background-color:var(--color-background-hover)}:host ::ng-deep .ap-search-input:hover:not(.disabled) .ap-search-after-icon.showDeleteIcon:hover{background:var(--color-background-hover-selected)}:host ::ng-deep .ap-search-input.disabled{cursor:not-allowed;box-shadow:inset 0 0 0 .0625rem var(--color-text-disabled)}:host ::ng-deep .ap-search-input.disabled .ap-field-input{cursor:not-allowed;color:var(--color-text-disabled)}:host ::ng-deep .ap-search-input.disabled .ap-field-input::placeholder{color:var(--color-text-disabled)}:host ::ng-deep .ap-search-input.disabled .icon-search-outline{color:var(--color-text-disabled)}:host ::ng-deep .ap-search-input.disabled .icon-return-outline:before{opacity:var(--opacity-3)}:host ::ng-deep .ap-search-input.disabled .ap-search-after-icon.disabled,:host ::ng-deep .ap-search-input.disabled .ap-search-after-icon.disabled:hover{cursor:not-allowed;pointer-events:none}:host ::ng-deep .ap-search-input.disabled .ap-search-after-icon.disabled.delete-icon,:host ::ng-deep .ap-search-input.disabled .ap-search-after-icon.disabled:hover.delete-icon{cursor:not-allowed;pointer-events:none}:host ::ng-deep .ap-search-input.disabled .ap-search-after-icon.disabled.delete-icon.showDeleteIcon,:host ::ng-deep .ap-search-input.disabled .ap-search-after-icon.disabled.delete-icon.showDeleteIcon.active,:host ::ng-deep .ap-search-input.disabled .ap-search-after-icon.disabled:hover.delete-icon.showDeleteIcon,:host ::ng-deep .ap-search-input.disabled .ap-search-after-icon.disabled:hover.delete-icon.showDeleteIcon.active{cursor:not-allowed;pointer-events:none;color:var(--color-text-disabled);opacity:0}:host ::ng-deep .ap-search-input.disabled .ap-search-after-icon.disabled.delete-icon.showDeleteIcon .icon-circle-delete-outline:hover,:host ::ng-deep .ap-search-input.disabled .ap-search-after-icon.disabled.delete-icon.showDeleteIcon.active .icon-circle-delete-outline:hover,:host ::ng-deep .ap-search-input.disabled .ap-search-after-icon.disabled:hover.delete-icon.showDeleteIcon .icon-circle-delete-outline:hover,:host ::ng-deep .ap-search-input.disabled .ap-search-after-icon.disabled:hover.delete-icon.showDeleteIcon.active .icon-circle-delete-outline:hover{cursor:not-allowed;pointer-events:none}:host ::ng-deep .ap-search-input.readonly{cursor:not-allowed;box-shadow:inset 0 0 0 .0625rem var(--color-text-disabled);pointer-events:none}:host ::ng-deep .ap-search-input.readonly .ap-field-input{cursor:not-allowed;pointer-events:none;color:var(--color-text-heading)}:host ::ng-deep .ap-search-input.readonly .ap-field-input::placeholder{color:var(--color-text-heading)}:host ::ng-deep .ap-search-input.readonly .icon-search-outline:before{opacity:var(--opacity-3)}:host ::ng-deep .ap-search-input.readonly .icon-return-outline:before{opacity:var(--opacity-3)}:host ::ng-deep .ap-search-input.readonly .ap-search-after-icon.disabled,:host ::ng-deep .ap-search-input.readonly .ap-search-after-icon.disabled:hover{cursor:not-allowed;pointer-events:none}:host ::ng-deep .ap-search-input.readonly .ap-search-after-icon.disabled.delete-icon,:host ::ng-deep .ap-search-input.readonly .ap-search-after-icon.disabled:hover.delete-icon{cursor:not-allowed;pointer-events:none}:host ::ng-deep .ap-search-input.readonly .ap-search-after-icon.disabled.delete-icon.showDeleteIcon,:host ::ng-deep .ap-search-input.readonly .ap-search-after-icon.disabled.delete-icon.showDeleteIcon.active,:host ::ng-deep .ap-search-input.readonly .ap-search-after-icon.disabled:hover.delete-icon.showDeleteIcon,:host ::ng-deep .ap-search-input.readonly .ap-search-after-icon.disabled:hover.delete-icon.showDeleteIcon.active{cursor:not-allowed;pointer-events:none}:host ::ng-deep .ap-search-input.readonly .ap-search-after-icon.disabled.delete-icon.showDeleteIcon .icon-circle-delete-outline:hover,:host ::ng-deep .ap-search-input.readonly .ap-search-after-icon.disabled.delete-icon.showDeleteIcon.active .icon-circle-delete-outline:hover,:host ::ng-deep .ap-search-input.readonly .ap-search-after-icon.disabled:hover.delete-icon.showDeleteIcon .icon-circle-delete-outline:hover,:host ::ng-deep .ap-search-input.readonly .ap-search-after-icon.disabled:hover.delete-icon.showDeleteIcon.active .icon-circle-delete-outline:hover{cursor:not-allowed;pointer-events:none}:host ::ng-deep .ap-search-input .icon-search-outline{position:absolute;left:0;margin-left:var(--spacing-3);color:var(--color-text-body)}:host ::ng-deep .ap-search-input .icon-search-outline:before{font-weight:var(--font-weight-2)}:host ::ng-deep .ap-search-input .ap-search-after-icon{position:absolute;opacity:0;right:0;justify-content:center;align-items:center;margin-right:var(--spacing-2);letter-spacing:-.025rem;width:2.5rem;height:2.5rem;border-radius:var(--border-radius-1);visibility:hidden;color:var(--color-text-body)}:host ::ng-deep .ap-search-input .ap-search-after-icon.enter-icon{padding:var(--spacing-4);visibility:visible}:host ::ng-deep .ap-search-input .ap-search-after-icon.enter-icon .Appkit4-icon{font-size:.75rem;width:1rem;height:1rem;line-height:1rem;color:var(--color-text-body)}:host ::ng-deep .ap-search-input .ap-search-after-icon.enter-icon .Appkit4-icon:before{font-weight:var(--font-weight-2)}:host ::ng-deep .ap-search-input .ap-search-after-icon.enter-icon.showPressIcon{opacity:var(--opacity-7);display:inline-flex}:host ::ng-deep .ap-search-input .ap-search-after-icon.delete-icon{padding:var(--spacing-3);visibility:visible}:host ::ng-deep .ap-search-input .ap-search-after-icon.delete-icon.showDeleteIcon{cursor:not-allowed;opacity:var(--opacity-3);visibility:visible;display:inline-flex;color:var(--color-text-body)}:host ::ng-deep .ap-search-input .ap-search-after-icon.delete-icon.showDeleteIcon:hover{cursor:not-allowed;background:var(--color-background-hover)}:host ::ng-deep .ap-search-input .ap-search-after-icon.delete-icon.showDeleteIcon.active{cursor:pointer;opacity:var(--opacity-7);pointer-events:visibleFill}:host ::ng-deep .ap-search-input .ap-search-after-icon.delete-icon.showDeleteIcon.active .icon-circle-delete-outline{color:var(--color-text-body)}:host ::ng-deep .ap-search-input .ap-search-after-icon:hover:not(.disabled){cursor:pointer;background-color:var(--color-background-hover-selected)}:host ::ng-deep .ap-search-input:focus:not(.disabled):not(.readonly):not(.keyboard-focus),:host ::ng-deep .ap-search-input:focus-within:not(.disabled):not(.readonly):not(.keyboard-focus){box-shadow:inset 0 0 0 .0625rem var(--color-background-primary),0 0 0 .25rem rgba(var(--color-background-primary-rgb),var(--opacity-3))}:host ::ng-deep .ap-search-input:focus:not(.disabled):not(.readonly):not(.keyboard-focus) .icon-search-outline,:host ::ng-deep .ap-search-input:focus-within:not(.disabled):not(.readonly):not(.keyboard-focus) .icon-search-outline{color:var(--color-text-heading)}:host ::ng-deep .ap-search-input:focus-within:not(.disabled):not(.readonly).focus.keyboard-focus{outline:auto .125rem Highlight;outline:auto .3125rem -webkit-focus-ring-color;outline-offset:var(--spacing-1)}:host ::ng-deep .ap-search-input:focus-within:not(.disabled):not(.readonly).focus.keyboard-focus .icon-circle-delete-outline{outline:none;outline-offset:0}:host ::ng-deep .ap-search-input:focus-within:not(.disabled):not(.readonly).focus.keyboard-focus .icon-search-outline{color:var(--color-text-heading)}:host ::ng-deep .ap-search-input:focus-within:not(.disabled):not(.readonly).focus.keyboard-focus .icon-search-outline:before{color:var(--color-text-heading)}:host ::ng-deep .ap-search-input:not(.disabled):not(.error):not(.readonly):not(:focus-within) .ap-search-wrapper:hover{background-color:var(--color-background-hover)}:host ::ng-deep .ap-search-container{border-radius:var(--border-radius-3);transition:height .3s;transform-origin:bottom;position:relative;display:block;width:100%;padding:var(--spacing-3)}:host ::ng-deep .ap-search-container .ap-search-list{padding-top:var(--spacing-3);z-index:99;background-color:var(--color-background-container);color:var(--color-text-heading)}:host ::ng-deep .ap-search-container .ap-search-list .ap-option-item{position:relative;width:100%;height:3rem;margin-bottom:var(--spacing-2);padding:var(--spacing-4) var(--spacing-3);border-radius:var(--border-radius-2);cursor:pointer;display:flex;justify-content:space-between;align-items:center;line-height:1.5rem;color:var(--color-text-body)}:host ::ng-deep .ap-search-container .ap-search-list .ap-option-item:last-child{margin-bottom:0}:host ::ng-deep .ap-search-container .ap-search-list .ap-option-item .ap-option-label{padding-right:2.75rem}:host ::ng-deep .ap-search-container .ap-search-list .ap-option-item.noResult{justify-content:center;margin-bottom:0!important}:host ::ng-deep .ap-search-container .ap-search-list .ap-option-item.noResult:hover{cursor:auto;background-color:var(--color-background-container)}:host ::ng-deep .ap-search-container .ap-search-list .ap-option-item.noResult .ap-option-label{padding-right:0}:host ::ng-deep .ap-search-container .ap-search-list .ap-option-item.active{background:var(--color-background-container)}:host ::ng-deep .ap-search-container .ap-search-list .ap-option-item.active:hover{background-color:var(--color-background-hover)}:host ::ng-deep .ap-search-container .ap-search-list ap-dropdown-list-item:last-child .ap-option-item{margin-bottom:0!important}:host ::ng-deep .ap-search-container .ap-search-list ap-dropdown-list-item:not(:last-child) .ap-option-item{margin-bottom:var(--spacing-2)!important}:host ::ng-deep .ap-search-container.show{box-shadow:inset 0 0 0 .0625rem var(--color-background-border);background-color:var(--color-background-container)}:host ::ng-deep .ap-field-input{width:100%;color:var(--color-text-heading);-webkit-appearance:none;background-color:transparent;outline:0!important;cursor:pointer;letter-spacing:-.025rem;padding:var(--spacing-4) 2.75rem var(--spacing-4) 2.25rem;transition:padding-top .3s,padding-bottom .3s,color .3s;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}:host ::ng-deep .ap-field-input.disabled{pointer-events:none;cursor:not-allowed;border:solid .0625rem var(--color-text-disabled)}:host ::ng-deep .ap-field-input::placeholder{font-size:1rem;line-height:1.5rem;letter-spacing:-.025rem;color:var(--color-text-light)}:host ::ng-deep .ap-field-input:focus::placeholder{color:transparent}:host ::ng-deep input{height:3rem;line-height:3rem}:host ::ng-deep input::placeholder{color:var(--color-text-light);opacity:1}:host ::ng-deep .search-result{border:0;clip:rect(0px,0px,0px,0px);height:.0625rem;margin-bottom:-.0625rem;margin-right:-.0625rem;overflow:hidden;padding:0;position:absolute;white-space:nowrap;width:.0625rem}\n"], dependencies: [{ kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i3.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i3.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i3.NgForm, selector: "form:not([ngNoForm]):not([formGroup]),ng-form,[ngForm]", inputs: ["ngFormOptions"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i4.NgClickOutsideDirective, selector: "[clickOutside]", inputs: ["clickOutsideEnabled", "attachOutsideOnClick", "delayClickOutsideInit", "emitOnBlur", "exclude", "excludeBeforeClick", "clickOutsideEvents"], outputs: ["clickOutside"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: SearchComponent, decorators: [{
            type: Component,
            args: [{ selector: "ap-search", exportAs: "apSearch", providers: [SEARCH_VALUE_ACCESSOR], template: "<form\n  #searchContainer\n  class=\"ap-search-container {{ styleClass }}\"\n  [class.show]=\"showList\"\n  (keyup)=\"onSearchContainerKeyUp($event)\"\n  (keydown)=\"onSearchContainerKeyDown($event)\"\n  (clickOutside)=\"onClickOut($event)\">\n  <div class=\"search-result\"  aria-live=\"assertive\" aria-atomic= \"true\">{{ searchStatus }}</div>\n  <div\n    class=\"ap-search-input\"\n    [class.disabled]=\"disabled\"\n    (keydown)=\"onSearchKeydown($event)\">\n    <input\n      type=\"text\"\n      #searchInput\n      [attr.role]=\"role\"\n      class=\"ap-field-input\"  \n      [attr.autocomplete]=\"autocomplete\"\n      [attr.aria-disabled]=\"disabled\"\n      [attr.aria-label]=\"ariaLabel\"\n      [attr.id]=\"inputId\"\n      [tabindex]=\"tabindex\"\n      [attr.aria-activedescendant]=\"activeId ? activeId : null \"\n      [attr.autofocus]=\"autoFocus\"\n      [class.disabled]=\"disabled\"\n      [class.error]=\"error\"\n      [class.readonly]=\"readonly\"\n      [placeholder]=\"placeholder\"\n      [disabled]=\"disabled\"\n      (input)=\"onInputChange($event)\"\n      (focus)=\"OnInputFocus($event)\"\n      (blur)=\"OnInputBlur($event)\"\n      (keydown)=\"onInputKeydown($event)\"\n      />\n    <span\n      class=\"Appkit4-icon icon-search-outline\"\n      [class.activeSearch]=\"activeSearch\"\n      [attr.aria-hidden]=\"true\"></span>\n\n    <span\n      *ngIf=\"searchType === 'primary'\"\n      role=\"button\"\n      #primaryIcon\n      [attr.tabindex]=\"tabindex || (!showPressIcon ? -1 : 0)\"\n      [attr.aria-label]=\"getLabel('search')\"\n      [attr.aria-disabled]=\"!showPressIcon\"\n      [attr.aria-hidden]=\"!showPressIcon\"\n      [tabindex]=\"disabled ? -1 : 0\"\n      [class.showPressIcon]=\"showPressIcon\"\n      [class.disabled]=\"disabled\"\n      class=\"ap-search-after-icon enter-icon\"\n      (click)=\"onStartSearch($event)\">\n      <span [attr.aria-hidden]=\"true\" class=\"Appkit4-icon icon-return-outline\"></span>\n    </span>\n\n    <span\n      #secondaryDelIcon\n      *ngIf=\"searchType !== 'primary'\"\n      role=\"button\"\n      type=\"button\"\n      [class.showDeleteIcon]=\"showDeleteIcon\"\n      [class.active]=\"fileldActiveDelete\"\n      [class.disabled]=\"disabled\"\n      class=\"ap-search-after-icon delete-icon\"\n      [attr.aria-label]=\"getLabel('clear')\"\n      [attr.aria-disabled]=\"!fileldActiveDelete\"\n      [attr.tabindex]=\"tabindex || (!fileldActiveDelete ? -1 : 0)\"\n      (focus)=\"onFocusDelIcon()\"\n      (blur)=\"onBlurDelIcon()\"\n      (click)=\"fileldActiveDelete && onDeleteInput($event)\">\n      <span class=\"Appkit4-icon icon-circle-delete-outline\"></span>\n    </span>\n  </div>\n  <ng-container>\n    <div class=\"ap-search-list\" *ngIf=\"showList\" [attr.role]=\"'listbox'\" [attr.aria-label]=\"'Option List'\">\n      <ng-content></ng-content>\n      <ng-container *ngIf=\"showBlankPage\">\n        <ng-container *ngIf=\"!isRecentSearch\">\n          <div class=\"ap-option-item noResult\" role=\"option\"> \n            <span class=\"ap-option-label\">{{ _noResultMessage }}</span>\n          </div>\n        </ng-container>\n        <ng-container *ngIf=\"isRecentSearch\">\n          <div class=\"ap-option-item noResult\" role=\"option\">\n            <span *ngIf=\"!showHistoryMsg\" class=\"ap-option-label\">{{\n              _noResultMessage\n              }}</span>\n            <span *ngIf=\"showHistoryMsg\" class=\"ap-option-label\">{{\n              _noHistoryMessage\n              }}</span>\n          </div>\n        </ng-container>\n      </ng-container>\n    </div>\n  </ng-container>\n</form>\n", styles: [":host ::ng-deep .ap-search-input{position:relative;display:flex;align-items:center;flex-wrap:wrap;margin-bottom:0;box-shadow:inset 0 0 0 .0625rem var(--color-background-border);background-color:var(--color-background-container);border-radius:var(--border-radius-2);overflow:hidden;transition:color .3s,background-color .3s,box-shadow .3s}:host ::ng-deep .ap-search-input:hover:not(.disabled){background-color:var(--color-background-hover)}:host ::ng-deep .ap-search-input:hover:not(.disabled) .ap-search-after-icon.showDeleteIcon:hover{background:var(--color-background-hover-selected)}:host ::ng-deep .ap-search-input.disabled{cursor:not-allowed;box-shadow:inset 0 0 0 .0625rem var(--color-text-disabled)}:host ::ng-deep .ap-search-input.disabled .ap-field-input{cursor:not-allowed;color:var(--color-text-disabled)}:host ::ng-deep .ap-search-input.disabled .ap-field-input::placeholder{color:var(--color-text-disabled)}:host ::ng-deep .ap-search-input.disabled .icon-search-outline{color:var(--color-text-disabled)}:host ::ng-deep .ap-search-input.disabled .icon-return-outline:before{opacity:var(--opacity-3)}:host ::ng-deep .ap-search-input.disabled .ap-search-after-icon.disabled,:host ::ng-deep .ap-search-input.disabled .ap-search-after-icon.disabled:hover{cursor:not-allowed;pointer-events:none}:host ::ng-deep .ap-search-input.disabled .ap-search-after-icon.disabled.delete-icon,:host ::ng-deep .ap-search-input.disabled .ap-search-after-icon.disabled:hover.delete-icon{cursor:not-allowed;pointer-events:none}:host ::ng-deep .ap-search-input.disabled .ap-search-after-icon.disabled.delete-icon.showDeleteIcon,:host ::ng-deep .ap-search-input.disabled .ap-search-after-icon.disabled.delete-icon.showDeleteIcon.active,:host ::ng-deep .ap-search-input.disabled .ap-search-after-icon.disabled:hover.delete-icon.showDeleteIcon,:host ::ng-deep .ap-search-input.disabled .ap-search-after-icon.disabled:hover.delete-icon.showDeleteIcon.active{cursor:not-allowed;pointer-events:none;color:var(--color-text-disabled);opacity:0}:host ::ng-deep .ap-search-input.disabled .ap-search-after-icon.disabled.delete-icon.showDeleteIcon .icon-circle-delete-outline:hover,:host ::ng-deep .ap-search-input.disabled .ap-search-after-icon.disabled.delete-icon.showDeleteIcon.active .icon-circle-delete-outline:hover,:host ::ng-deep .ap-search-input.disabled .ap-search-after-icon.disabled:hover.delete-icon.showDeleteIcon .icon-circle-delete-outline:hover,:host ::ng-deep .ap-search-input.disabled .ap-search-after-icon.disabled:hover.delete-icon.showDeleteIcon.active .icon-circle-delete-outline:hover{cursor:not-allowed;pointer-events:none}:host ::ng-deep .ap-search-input.readonly{cursor:not-allowed;box-shadow:inset 0 0 0 .0625rem var(--color-text-disabled);pointer-events:none}:host ::ng-deep .ap-search-input.readonly .ap-field-input{cursor:not-allowed;pointer-events:none;color:var(--color-text-heading)}:host ::ng-deep .ap-search-input.readonly .ap-field-input::placeholder{color:var(--color-text-heading)}:host ::ng-deep .ap-search-input.readonly .icon-search-outline:before{opacity:var(--opacity-3)}:host ::ng-deep .ap-search-input.readonly .icon-return-outline:before{opacity:var(--opacity-3)}:host ::ng-deep .ap-search-input.readonly .ap-search-after-icon.disabled,:host ::ng-deep .ap-search-input.readonly .ap-search-after-icon.disabled:hover{cursor:not-allowed;pointer-events:none}:host ::ng-deep .ap-search-input.readonly .ap-search-after-icon.disabled.delete-icon,:host ::ng-deep .ap-search-input.readonly .ap-search-after-icon.disabled:hover.delete-icon{cursor:not-allowed;pointer-events:none}:host ::ng-deep .ap-search-input.readonly .ap-search-after-icon.disabled.delete-icon.showDeleteIcon,:host ::ng-deep .ap-search-input.readonly .ap-search-after-icon.disabled.delete-icon.showDeleteIcon.active,:host ::ng-deep .ap-search-input.readonly .ap-search-after-icon.disabled:hover.delete-icon.showDeleteIcon,:host ::ng-deep .ap-search-input.readonly .ap-search-after-icon.disabled:hover.delete-icon.showDeleteIcon.active{cursor:not-allowed;pointer-events:none}:host ::ng-deep .ap-search-input.readonly .ap-search-after-icon.disabled.delete-icon.showDeleteIcon .icon-circle-delete-outline:hover,:host ::ng-deep .ap-search-input.readonly .ap-search-after-icon.disabled.delete-icon.showDeleteIcon.active .icon-circle-delete-outline:hover,:host ::ng-deep .ap-search-input.readonly .ap-search-after-icon.disabled:hover.delete-icon.showDeleteIcon .icon-circle-delete-outline:hover,:host ::ng-deep .ap-search-input.readonly .ap-search-after-icon.disabled:hover.delete-icon.showDeleteIcon.active .icon-circle-delete-outline:hover{cursor:not-allowed;pointer-events:none}:host ::ng-deep .ap-search-input .icon-search-outline{position:absolute;left:0;margin-left:var(--spacing-3);color:var(--color-text-body)}:host ::ng-deep .ap-search-input .icon-search-outline:before{font-weight:var(--font-weight-2)}:host ::ng-deep .ap-search-input .ap-search-after-icon{position:absolute;opacity:0;right:0;justify-content:center;align-items:center;margin-right:var(--spacing-2);letter-spacing:-.025rem;width:2.5rem;height:2.5rem;border-radius:var(--border-radius-1);visibility:hidden;color:var(--color-text-body)}:host ::ng-deep .ap-search-input .ap-search-after-icon.enter-icon{padding:var(--spacing-4);visibility:visible}:host ::ng-deep .ap-search-input .ap-search-after-icon.enter-icon .Appkit4-icon{font-size:.75rem;width:1rem;height:1rem;line-height:1rem;color:var(--color-text-body)}:host ::ng-deep .ap-search-input .ap-search-after-icon.enter-icon .Appkit4-icon:before{font-weight:var(--font-weight-2)}:host ::ng-deep .ap-search-input .ap-search-after-icon.enter-icon.showPressIcon{opacity:var(--opacity-7);display:inline-flex}:host ::ng-deep .ap-search-input .ap-search-after-icon.delete-icon{padding:var(--spacing-3);visibility:visible}:host ::ng-deep .ap-search-input .ap-search-after-icon.delete-icon.showDeleteIcon{cursor:not-allowed;opacity:var(--opacity-3);visibility:visible;display:inline-flex;color:var(--color-text-body)}:host ::ng-deep .ap-search-input .ap-search-after-icon.delete-icon.showDeleteIcon:hover{cursor:not-allowed;background:var(--color-background-hover)}:host ::ng-deep .ap-search-input .ap-search-after-icon.delete-icon.showDeleteIcon.active{cursor:pointer;opacity:var(--opacity-7);pointer-events:visibleFill}:host ::ng-deep .ap-search-input .ap-search-after-icon.delete-icon.showDeleteIcon.active .icon-circle-delete-outline{color:var(--color-text-body)}:host ::ng-deep .ap-search-input .ap-search-after-icon:hover:not(.disabled){cursor:pointer;background-color:var(--color-background-hover-selected)}:host ::ng-deep .ap-search-input:focus:not(.disabled):not(.readonly):not(.keyboard-focus),:host ::ng-deep .ap-search-input:focus-within:not(.disabled):not(.readonly):not(.keyboard-focus){box-shadow:inset 0 0 0 .0625rem var(--color-background-primary),0 0 0 .25rem rgba(var(--color-background-primary-rgb),var(--opacity-3))}:host ::ng-deep .ap-search-input:focus:not(.disabled):not(.readonly):not(.keyboard-focus) .icon-search-outline,:host ::ng-deep .ap-search-input:focus-within:not(.disabled):not(.readonly):not(.keyboard-focus) .icon-search-outline{color:var(--color-text-heading)}:host ::ng-deep .ap-search-input:focus-within:not(.disabled):not(.readonly).focus.keyboard-focus{outline:auto .125rem Highlight;outline:auto .3125rem -webkit-focus-ring-color;outline-offset:var(--spacing-1)}:host ::ng-deep .ap-search-input:focus-within:not(.disabled):not(.readonly).focus.keyboard-focus .icon-circle-delete-outline{outline:none;outline-offset:0}:host ::ng-deep .ap-search-input:focus-within:not(.disabled):not(.readonly).focus.keyboard-focus .icon-search-outline{color:var(--color-text-heading)}:host ::ng-deep .ap-search-input:focus-within:not(.disabled):not(.readonly).focus.keyboard-focus .icon-search-outline:before{color:var(--color-text-heading)}:host ::ng-deep .ap-search-input:not(.disabled):not(.error):not(.readonly):not(:focus-within) .ap-search-wrapper:hover{background-color:var(--color-background-hover)}:host ::ng-deep .ap-search-container{border-radius:var(--border-radius-3);transition:height .3s;transform-origin:bottom;position:relative;display:block;width:100%;padding:var(--spacing-3)}:host ::ng-deep .ap-search-container .ap-search-list{padding-top:var(--spacing-3);z-index:99;background-color:var(--color-background-container);color:var(--color-text-heading)}:host ::ng-deep .ap-search-container .ap-search-list .ap-option-item{position:relative;width:100%;height:3rem;margin-bottom:var(--spacing-2);padding:var(--spacing-4) var(--spacing-3);border-radius:var(--border-radius-2);cursor:pointer;display:flex;justify-content:space-between;align-items:center;line-height:1.5rem;color:var(--color-text-body)}:host ::ng-deep .ap-search-container .ap-search-list .ap-option-item:last-child{margin-bottom:0}:host ::ng-deep .ap-search-container .ap-search-list .ap-option-item .ap-option-label{padding-right:2.75rem}:host ::ng-deep .ap-search-container .ap-search-list .ap-option-item.noResult{justify-content:center;margin-bottom:0!important}:host ::ng-deep .ap-search-container .ap-search-list .ap-option-item.noResult:hover{cursor:auto;background-color:var(--color-background-container)}:host ::ng-deep .ap-search-container .ap-search-list .ap-option-item.noResult .ap-option-label{padding-right:0}:host ::ng-deep .ap-search-container .ap-search-list .ap-option-item.active{background:var(--color-background-container)}:host ::ng-deep .ap-search-container .ap-search-list .ap-option-item.active:hover{background-color:var(--color-background-hover)}:host ::ng-deep .ap-search-container .ap-search-list ap-dropdown-list-item:last-child .ap-option-item{margin-bottom:0!important}:host ::ng-deep .ap-search-container .ap-search-list ap-dropdown-list-item:not(:last-child) .ap-option-item{margin-bottom:var(--spacing-2)!important}:host ::ng-deep .ap-search-container.show{box-shadow:inset 0 0 0 .0625rem var(--color-background-border);background-color:var(--color-background-container)}:host ::ng-deep .ap-field-input{width:100%;color:var(--color-text-heading);-webkit-appearance:none;background-color:transparent;outline:0!important;cursor:pointer;letter-spacing:-.025rem;padding:var(--spacing-4) 2.75rem var(--spacing-4) 2.25rem;transition:padding-top .3s,padding-bottom .3s,color .3s;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}:host ::ng-deep .ap-field-input.disabled{pointer-events:none;cursor:not-allowed;border:solid .0625rem var(--color-text-disabled)}:host ::ng-deep .ap-field-input::placeholder{font-size:1rem;line-height:1.5rem;letter-spacing:-.025rem;color:var(--color-text-light)}:host ::ng-deep .ap-field-input:focus::placeholder{color:transparent}:host ::ng-deep input{height:3rem;line-height:3rem}:host ::ng-deep input::placeholder{color:var(--color-text-light);opacity:1}:host ::ng-deep .search-result{border:0;clip:rect(0px,0px,0px,0px);height:.0625rem;margin-bottom:-.0625rem;margin-right:-.0625rem;overflow:hidden;padding:0;position:absolute;white-space:nowrap;width:.0625rem}\n"] }]
        }], ctorParameters: () => [{ type: i0.Renderer2 }, { type: i0.ElementRef }, { type: i0.ChangeDetectorRef }, { type: i1.LocalizationConfig }], propDecorators: { inputViewChild: [{
                type: ViewChild,
                args: ["searchInput"]
            }], priamryIcon: [{
                type: ViewChild,
                args: ["primaryIcon"]
            }], secondaryDelIcon: [{
                type: ViewChild,
                args: ["secondaryDelIcon"]
            }], searchContainer: [{
                type: ViewChild,
                args: ["searchContainer"]
            }], dropdownListItem: [{
                type: ContentChildren,
                args: ['dropdownListItem']
            }], disabled: [{
                type: Input
            }], tabindex: [{
                type: Input
            }], ariaLabel: [{
                type: Input
            }], autoFocus: [{
                type: Input
            }], role: [{
                type: Input
            }], error: [{
                type: Input
            }], readonly: [{
                type: Input
            }], placeholder: [{
                type: Input
            }], inputId: [{
                type: Input
            }], searchType: [{
                type: Input
            }], autocomplete: [{
                type: Input
            }], filtered: [{
                type: Input
            }], list: [{
                type: Input
            }], styleClass: [{
                type: Input
            }], style: [{
                type: Input
            }], addDropdown: [{
                type: Input
            }], showPressIcon: [{
                type: Input
            }], showDeleteIcon: [{
                type: Input
            }], noResultMsg: [{
                type: Input
            }], noHistoryMsg: [{
                type: Input
            }], isRecentSearch: [{
                type: Input
            }], customKeydown: [{
                type: Input
            }], searchStatus: [{
                type: Input
            }], onSearch: [{
                type: Output
            }], onFocus: [{
                type: Output
            }], onBlur: [{
                type: Output
            }], onClear: [{
                type: Output
            }], onKeydown: [{
                type: Output
            }], onSaveLocalHistory: [{
                type: Output
            }], onClose: [{
                type: Output
            }], optionName: [{
                type: Input
            }], optionValue: [{
                type: Input
            }] } });

class SearchModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: SearchModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.11", ngImport: i0, type: SearchModule, declarations: [SearchComponent], imports: [CommonModule,
            FormsModule,
            NgClickOutsideDirective,
            DropdownListItemModule], exports: [SearchComponent,
            DropdownListItemModule,
            NgClickOutsideDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: SearchModule, imports: [CommonModule,
            FormsModule,
            DropdownListItemModule, DropdownListItemModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: SearchModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        FormsModule,
                        NgClickOutsideDirective,
                        DropdownListItemModule
                    ],
                    exports: [
                        SearchComponent,
                        DropdownListItemModule,
                        NgClickOutsideDirective
                    ],
                    declarations: [
                        SearchComponent
                    ]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { SEARCH_VALUE_ACCESSOR, SearchComponent, SearchModule };
